import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';

const AdminRoute = ({ children }) => {
  const { user, isAuthenticated, authStatus } = useSelector((state) => state.auth);

  // Use ProtectedRoute to handle authentication check
  return (
    <ProtectedRoute 
      requireAuth={true}
      redirectTo="/"  // Redirect to home if not authenticated
    >
      {/* Check if user is staff after authentication is confirmed */}
      {isAuthenticated && user && !user.is_staff ? (
        <Navigate to="/" replace />
      ) : (
        children
      )}
    </ProtectedRoute>
  );
};

export default AdminRoute;